import { get } from "svelte/store";
import { getSavedIpForAdmin } from "./localStorage";
import { adminId, businessId } from "../store";

const EXPIRATION_TIME = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

function showOnlyOnce(data, widgetType) {
  if (
    data.openOnce === true &&
    data.turnOffCookies !== true &&
    widgetType == 'classic'
  ) {
    if (document.cookie.indexOf('wWidgetOnlyOnce') == -1) {
      document.cookie = 'wWidgetOnlyOnce=true'
    } else {
      return false
    }
  } else if (widgetType == 'classic') {
    document.cookie =
      'wWidgetOnlyOnce=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
  }
  return true
}

function getHue(rgbColor) {
  let r = 0,
    g = 0,
    b = 0
  if (rgbColor === undefined) return 0
  // 3 digits
  if (rgbColor.length == 4) {
    r = '0x' + rgbColor[1] + rgbColor[1]
    g = '0x' + rgbColor[2] + rgbColor[2]
    b = '0x' + rgbColor[3] + rgbColor[3]

    // 6 digits
  } else if (rgbColor.length == 7) {
    r = '0x' + rgbColor[1] + rgbColor[2]
    g = '0x' + rgbColor[3] + rgbColor[4]
    b = '0x' + rgbColor[5] + rgbColor[6]
  }
  if (Math.abs(r - g) <= 10 && Math.abs(g - b) <= 10 && Math.abs(b - r) <= 10)
    return -1
  r /= 255
  g /= 255
  b /= 255

  // Find greatest and smallest channel values
  let cmin = Math.min(r, g, b),
    cmax = Math.max(r, g, b),
    delta = cmax - cmin,
    h = 0,
    s = 0,
    l = 0
  // Calculate hue
  // No difference
  if (delta == 0) h = 0
  // Red is max
  else if (cmax == r) h = ((g - b) / delta) % 6
  // Green is max
  else if (cmax == g) h = (b - r) / delta + 2
  // Blue is max
  else h = (r - g) / delta + 4

  h = Math.round(h * 60)

  // Make negative hues positive behind 360°
  if (h < 0) h += 360
  return h
}

function padValue(value, length = 2, char = '0') {
  if (value > 99) return 99
  const { length: currentLength } = value.toString()
  if (currentLength >= length) return value.toString()
  return `${char.repeat(length - currentLength)}${value}`
}

const conf = [
  {
    id: 'Return',
    name: 'Returns',
    color: '#F2DFC4',
    icon: 'https://widget.tochat.be/faq-icons/box.png',
  },
  {
    id: 'Broken',
    name: 'Broken',
    color: '#E8B5B0',
    icon: 'https://widget.tochat.be/faq-icons/broken-heart.png',
  },
  {
    id: 'Discount',
    name: 'Returns',
    color: '#D9DBC3',
    icon: 'https://widget.tochat.be/faq-icons/money-bag.png',
  },
  {
    id: 'Delivery',
    name: 'Returns',
    color: '#D7EEF6',
    icon: 'https://widget.tochat.be/faq-icons/broken-heart.png',
  },
]

const getConf = (id) => conf.find((o) => o.id == id)

const getproperty = (id, type) => {
  const obj = getConf(id)
  if (obj && obj.hasOwnProperty(type)) {
    return obj[type]
  } else {
    return ''
  }
}

const toArray = (data) => {
  return data.split('|')
}

const getWrittenName = (data, dataObject, showPrices, currency, showDurations) => {
  if (!dataObject) {
    return data;
  }

  const price = dataObject.find(obj => obj?.value === data)?.price;
  const writtenName = dataObject.find(obj => (obj?.value === data) && (obj?.writtenName !== ''))?.writtenName;
  const duration = dataObject.find(obj => obj?.value === data)?.duration;

  const formatDuration = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    if (hours > 0 && remainingMinutes > 0) {
      return `${hours}h ${remainingMinutes}m`;
    } else if (hours > 0) {
      return `${hours}h`;
    } else {
      return `${remainingMinutes}m`;
    }
  };

  let result = showPrices ? `${writtenName ?? data} (${price} ${currency ?? 'USD'})` : (writtenName ?? data);
  if (showDurations && duration) {
    result += ` - ${formatDuration(duration)}`;
  }
  return result;
}

const splitNameAndPrice = (text) => {
  // Regex para detectar el nombre, precio y duración
  const regex = /^(.*?)(?:\(([\d\sA-Z]+)\))?(?:\s*-\s*(\d+h\s*\d*m?|\d+m))?$/;
  const matches = text.match(regex);

  // Si hay coincidencias, devolvemos cada parte encontrada
  if (matches) {
    return {
      name: matches[1].trim(),                     // Nombre
      price: matches[2] ? matches[2].trim() : '',  // Precio (si existe)
      duration: matches[3] ? matches[3].trim() : ''// Duración (si existe)
    };
  }

  // Si no hay coincidencias, devolvemos solo el nombre
  return {
    name: text.trim(),
    price: '',
    duration: ''
  };
}

const isMobile = () => {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

const isIPhone = () => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

// Get the location of a postal code
async function fetchLocation(postalCode, country) {
  try {
    const response = await fetch("https://postcode-server.fly.dev/lookup", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        country: country,
        postcode: postalCode
      })
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      // Handle error
      return null;
    }
  } catch (error) {
    // Handle error
    return null;
  }
}

// Check if some item close the conversation
const checkIfSomeItemCloseConversation = (items) => {
  return items.some((item) => {
    if (item.type === "select" || item.type === "selectAndPrice") {
      if (item.val) {
        const option = item.dataObject?.find((obj) => obj.value === item.val);
        return option?.closeConversation;
      }
    }
    if (item.type === "email" && item.filterDomain) {
      if (item.val) {
        let domain = item.val.split("@")[1];
        domain = domain.split(".")[0];
        if (domain === "gmail" || domain === "hotmail") {
          return true;
        }
      }
    }
    if (item.type === "zipcode") {
      if (checkZipCodeExclusions(item)) {
        return true;
      }
    }
    if (item.type === "tel") {
      if (checkPhoneAreaCodeExclusions(item)) {
        return true;
      }
    }
    return false;
  });
}

const lightOrDark = (color) => {
  // Check the format of the color, HEX or RGB?
  let r, g, b
  if (color.match(/^rgb/)) {
    // If HEX --> store the red, green, blue values in separate variables
    color = color.match(
      /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/,
    )

    r = color[1]
    g = color[2]
    b = color[3]
  } else {
    // If RGB --> Convert it to HEX: http://gist.github.com/983661
    color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'))

    r = color >> 16
    g = (color >> 8) & 255
    b = color & 255
  }

  // HSP equation from http://alienryderflex.com/hsp.html
  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))

  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 197.5) {
    return 'black'
  } else {
    return 'white'
  }
}

const trimUrlPeriod = (url) => {
  return url.endsWith('.') ? url.slice(0, -1) : url;
}

const addHttpsToUrl = (url) => {
  return url.startsWith('http') ? url : `https://${url}`;
}

const URL_INPUT_PREFIX = "https://";

const normalizeUrlFieldValue = (value) => {
  if (value === undefined || value === null) return "";
  if (typeof value !== "string") return value;
  return value.trim() === URL_INPUT_PREFIX ? "" : value.trim();
}

const ensureUrlFieldPrefix = (value) => {
  return normalizeUrlFieldValue(value) === "" ? URL_INPUT_PREFIX : value;
}

const escapeHtml = (str) => {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

// Extracts a clean, human-readable label from a URL (the domain without "www.").
const getUrlLabel = (url) => {
  try {
    return new URL(addHttpsToUrl(url)).hostname.replace(/^www\./, '');
  } catch (e) {
    return url.replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0];
  }
}

// Builds a Google/ChatGPT-style "chip" for a link: a small pill with the site
// favicon and a short label, instead of pasting the full raw URL.
const buildLinkChip = (rawUrl, label) => {
  const url = addHttpsToUrl(trimUrlPeriod(rawUrl));
  let host;
  try {
    host = new URL(url).hostname.replace(/^www\./, '');
  } catch (e) {
    host = getUrlLabel(url);
  }
  const text = (label && label.trim()) ? label.trim() : host;
  const favicon = `https://www.google.com/s2/favicons?domain=${encodeURIComponent(host)}&sz=64`;
  return `<a class="cw-link-chip" href="${escapeHtml(url)}" target="_blank" rel="noopener noreferrer">` +
    `<img class="cw-link-chip-favicon" src="${favicon}" alt="" aria-hidden="true" onerror="this.style.display='none'" />` +
    `<span class="cw-link-chip-label">${escapeHtml(text)}</span></a>`;
}

// Replaces markdown links [text](url) and plain URLs inside an HTML string with
// link chips, without escaping the surrounding HTML (used for already-HTML content
// like the freetext welcome message).
const linkifyUrlsToChips = (html) => {
  if (!html || typeof html !== 'string') return html || '';
  html = html.replace(/\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g, (_, linkText, url) => buildLinkChip(url, linkText));
  const urlRegex = /(?<!<a\s+[^>]*?href=["'])(?<!src=["'])https?:\/\/[^\s<"']+(?![^<]*<\/a>)/g;
  return html.replace(urlRegex, (url) => buildLinkChip(url, null));
}

// Converts the lightweight markdown the AI emits (short paragraphs, **bold**,
// *italic*, "- " bullets, "1." numbered lists, links) into safe HTML for the chat
// bubble. HTML is escaped first, so AI text can never inject markup.
// Tags produced by the rich-text welcome editor (B / I / U / link) plus the
// wrappers it uses. If the content already contains these, it is authored HTML
// and must NOT be escaped — we only turn its URLs into chips.
const AUTHORED_HTML_RE = /<\/?(p|br|strong|b|em|i|u|a|ul|ol|li|h[1-6]|div|span)\b[^>]*>/i;

const formatRichText = (raw) => {
  if (!raw || typeof raw !== 'string') return raw || '';

  // Already-HTML content (e.g. the welcome message): keep the author's markup,
  // just upgrade plain URLs to chips. Escaping it would show literal <strong> tags.
  if (AUTHORED_HTML_RE.test(raw)) return linkifyUrlsToChips(raw);

  const chips = [];
  const stash = (chipHtml) => `@@CHIP${chips.push(chipHtml) - 1}@@`;

  // 1) Extract links BEFORE escaping so the raw URL (incl. & in query strings) survives.
  let text = raw.replace(/\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g, (_, label, url) => stash(buildLinkChip(url, label)));
  // 2) Plain URLs -> chips (markdown links are already stashed away).
  text = text.replace(/https?:\/\/[^\s<]+/g, (url) => stash(buildLinkChip(url, null)));

  // 3) Escape everything else (chips are safe ASCII tokens).
  text = escapeHtml(text);

  // 4) Inline emphasis.
  text = text.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  text = text.replace(/(?<![*\w])\*([^*\n]+)\*(?![*\w])/g, '<em>$1</em>');

  // 5) Block layout: paragraphs and lists, line by line.
  const lines = text.split(/\r?\n/);
  let out = '';
  let listType = null;
  let paragraph = [];
  const closeList = () => { if (listType) { out += `</${listType}>`; listType = null; } };
  const flushParagraph = () => { if (paragraph.length) { out += `<p>${paragraph.join('<br/>')}</p>`; paragraph = []; } };

  for (const line of lines) {
    const trimmed = line.trim();
    if (trimmed === '') { flushParagraph(); closeList(); continue; }

    const heading = trimmed.match(/^#{1,6}\s+(.*)$/);
    if (heading) { flushParagraph(); closeList(); out += `<p><strong>${heading[1]}</strong></p>`; continue; }

    const bullet = trimmed.match(/^[-*•]\s+(.*)$/);
    if (bullet) {
      flushParagraph();
      if (listType !== 'ul') { closeList(); out += '<ul>'; listType = 'ul'; }
      out += `<li>${bullet[1]}</li>`;
      continue;
    }

    const ordered = trimmed.match(/^\d+[.)]\s+(.*)$/);
    if (ordered) {
      flushParagraph();
      if (listType !== 'ol') { closeList(); out += '<ol>'; listType = 'ol'; }
      out += `<li>${ordered[1]}</li>`;
      continue;
    }

    closeList();
    paragraph.push(trimmed);
  }
  flushParagraph();
  closeList();

  // 6) Restore chips.
  return out.replace(/@@CHIP(\d+)@@/g, (_, i) => chips[Number(i)]);
}

const checkZipCodeExclusions = (item) => {
  let closeConversationMessage;
  const mode = item.includeOrExclude || 'exclude'; // por defecto 'exclude'
  let match = false;

  item.dataObject?.forEach(ex => {
    const isPrefix = ex.value.endsWith('*');
    if (isPrefix) {
      const prefix = ex.value.slice(0, -1);
      if (item.val.startsWith(prefix)) {
        match = true;
        closeConversationMessage = ex.closeConversationMessage;
      }
    } else {
      if (item.val === ex.value) {
        match = true;
        closeConversationMessage = ex.closeConversationMessage;
      }
    }
  });

  // Si estamos en modo "exclude" devolvemos el mensaje cuando haya match
  // Si estamos en modo "include", devolvemos el mensaje si NO hay match
  if (mode === 'exclude' && match) {
    return closeConversationMessage;
  }

  if (mode === 'include' && !match) {
    // Si no hay match en modo include, devolvemos el primer mensaje que exista
    return item.dataObject?.[0]?.closeConversationMessage || null;
  }

  return null;
}

const checkPhoneAreaCodeExclusions = (item) => {
  let closeConversationMessage;
  const mode = item.includeOrExclude || 'exclude'; // por defecto 'exclude'
  let match = false;

  item.dataObject?.forEach(ex => {
    const isPrefix = ex.value.endsWith('*');
    if (isPrefix) {
      const prefix = ex.value.slice(0, -1);
      if (item.telNum?.startsWith(prefix)) {
        match = true;
        closeConversationMessage = ex.closeConversationMessage;
      }
    } else {
      if (item.telNum === ex.value) {
        match = true;
        closeConversationMessage = ex.closeConversationMessage;
      }
    }
  });

  // Si estamos en modo "exclude" devolvemos el mensaje cuando haya match
  // Si estamos en modo "include", devolvemos el mensaje si NO hay match
  if (mode === 'exclude' && match) {
    return closeConversationMessage;
  }

  if (mode === 'include' && !match) {
    // Si no hay match en modo include, devolvemos el primer mensaje que exista
    return item.dataObject?.[0]?.closeConversationMessage || null;
  }

  return null;
}

/**
 * Guarda el referer original en localStorage si aún no existe.
 * @param {string} widgetKey - Clave única del widget
 */
const setRefererWithExpiry = (widgetKey) => {
  const STORAGE_KEY = `tochatbe_origin_url_${widgetKey}`;
  if (!widgetKey || localStorage.getItem(STORAGE_KEY)) return;

  const value = {
    url: window.location.href,
    timestamp: Date.now()
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
};

/**
 * Recupera el referer original si no ha expirado.
 * @param {string} widgetKey - Clave única del widget
 * @returns {string|null}
 */
const getRefererWithExpiry = (widgetKey) => {
  const STORAGE_KEY = `tochatbe_origin_url_${widgetKey}`;
  const stored = localStorage.getItem(STORAGE_KEY);

  if (stored) {
    try {
      const { url, timestamp } = JSON.parse(stored);
      if (Date.now() - timestamp <= EXPIRATION_TIME) {
        return url;
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    } catch (e) {
      console.warn("Error al parsear el originalReferer:", e);
    }
  }

  return null;
};

/** * Obtiene la dirección IP del usuario utilizando la API de ipify.
 * @returns {Promise<string|null>} La dirección IP del usuario o null en caso de error.
 */
const getUserIP = async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error('Error fetching user IP:', error);
    return null;
  }
}

/** * Registra la conexión del cliente con el servidor.
 * @param {string} host - El host del servidor al que se va a registrar la conexión.
 * @returns {Promise<void>}
 */
const registerClientConnection = async (host) => {
  const admin = get(adminId);
  const business = get(businessId);

  if (!admin || !business) return;

  let ip = getSavedIpForAdmin();
  if (!ip) {
    ip = await getUserIP();
  }

  try {
    const res = await fetch(`${host}/api/clients-connected`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        admin: String(admin),
        business: String(business),
        ip
      })
    });

    if (!res.ok) {
      throw new Error(`Error registering client connection: ${res.statusText}`);
    }
  } catch (error) {
    console.error('Error registering client connection:', error);
  }
}

/**
 * Devuelve los click IDs (fbclid, gclid, ttclid, wbraid, gbraid) a partir de la URL original guardada,
 * o, si no existe / expiró, a partir de window.location.href y document.referrer.
 * @param {string|null} widgetKey
 * @returns {{FbClid: string|null, GClid: string|null, TTClid: string|null, WBraid: string|null, GBraid: string|null}}
 */
const getClickIds = (widgetKey) => {
  const originalUrl = widgetKey ? getRefererWithExpiry(widgetKey) : null;
  const urlsToCheck = [originalUrl, window.location?.href, document.referrer].filter(Boolean);

  let fbclid = null;
  let gclid = null;
  let ttclid = null;
  let wbraid = null;
  let gbraid = null;

  const sanitize = (val) =>
    val && typeof val === "string" ? val.replace(/[^a-zA-Z0-9_\-]/g, "") : null;

  for (const url of urlsToCheck) {
    try {
      const urlParams = new URLSearchParams(new URL(url, window.location.origin).search);
      fbclid = fbclid || sanitize(urlParams.get("fbclid"));
      gclid = gclid || sanitize(urlParams.get("gclid"));
      ttclid = ttclid || sanitize(urlParams.get("ttclid") || urlParams.get("tt_cid"));
      wbraid = wbraid || sanitize(urlParams.get("wbraid"));
      gbraid = gbraid || sanitize(urlParams.get("gbraid"));
    } catch (e) {
      console.warn("URL inválida en getClickIds:", url, e);
    }
  }

  return { FbClid: fbclid, GClid: gclid, TTClid: ttclid, WBraid: wbraid, GBraid: gbraid };
};

const interpolatePageVariables = (text) => {
  if (!text || typeof text !== 'string') return text;

  return text.replace(/\{([^}]+)\}/g, (match, key) => {
    const trimmedKey = key.trim();

    if (trimmedKey === 'title') return document.title || match;

    const metaByProperty = document.querySelector(`meta[property="${trimmedKey}"]`);
    if (metaByProperty) return metaByProperty.getAttribute('content') ?? match;

    const metaByName = document.querySelector(`meta[name="${trimmedKey}"]`);
    if (metaByName) return metaByName.getAttribute('content') ?? match;

    return match;
  });
};

const getAutocomplete = (item) => {
  if (item.type === "email") return "email";
  if (item.type === "tel") return "tel";
  if (item.type === "text") {
    const label = (item.label || "").toLowerCase();
    if (/\b(name|nombre|nom|nome|naam|name)\b/.test(label)) return "name";
  }
  return "on";
};

export { showOnlyOnce, getAutocomplete, getHue, padValue, getproperty, toArray, getWrittenName, splitNameAndPrice, isMobile, isIPhone, lightOrDark, fetchLocation, checkIfSomeItemCloseConversation, trimUrlPeriod, addHttpsToUrl, URL_INPUT_PREFIX, normalizeUrlFieldValue, ensureUrlFieldPrefix, checkZipCodeExclusions, checkPhoneAreaCodeExclusions, setRefererWithExpiry, getRefererWithExpiry, getUserIP, registerClientConnection, getClickIds, interpolatePageVariables, formatRichText, linkifyUrlsToChips };
